var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNrdtLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73 25H2.275V0.499998H3.465L18.025 23.145V0.499998H18.48V25H15.925L2.73 4.7V25Z",
    fill: "#FFA800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73 25H3.275V0.499998H4.465L19.025 23.145V0.499998H19.48V25H16.925L3.73 4.7V25Z",
    fill: "#FFB423"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73 25H4.275V0.499998H5.465L20.025 23.145V0.499998H20.48V25H17.925L4.73 4.7V25Z",
    fill: "#FFBB36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73 25H5.275V0.499998H6.465L21.025 23.145V0.499998H21.48V25H18.925L5.73 4.7V25Z",
    fill: "#FBCB6E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73 25H6.275V0.499998H7.465L22.025 23.145V0.499998H22.48V25H19.925L6.73 4.7V25Z",
    fill: "#FFD98F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNrdtLogo);
export default __webpack_public_path__ + "static/media/NRDTLogo.313d23bef90a484165aba41ea5f30bf6.svg";
export { ForwardRef as ReactComponent };